module.exports = __webpack_public_path__ + "img/code.48b3e8fc.jpg";